import React, { Component } from "react";

import {
  Card,
  Wrapper,
  CardBody,
  Row,
  Copy,
  Bold,
  Spin,
  Title
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";
import { skipTrace } from "app/NativeActions";
class SkipTraceButton extends Component {
  renderSkipTraceText() {
    const { owner_info, active_property } = this.props;
    var item_string = "";
    var contact_string = "";

    var has_phones = false;
    var has_emails = false;
    var has_addresses = false;

    var address_count = 0;
    var email_count = 0;
    var phone_count = 0;

    if (active_property.deal.skip_trace_phone_numbers_count != null) {
      phone_count = active_property.deal.skip_trace_phone_numbers_count;
      if (phone_count > 0) {
        has_phones = true;
      }
    }

    if (active_property.deal.skip_trace_email_addresses_count != null) {
      email_count = active_property.deal.skip_trace_email_addresses_count;
      if (email_count > 0) {
        has_emails = true;
      }
    }

    if (active_property.deal.skip_trace_mailing_addresses_count != null) {
      address_count = active_property.deal.skip_trace_mailing_addresses_count;
      if (address_count > 0) {
        has_addresses = true;
      }
    }
    if (has_phones) {
      if (phone_count === 1) {
        item_string += "1 phone number";
      } else {
        item_string += phone_count + " phone numbers";
      }

      if (!has_emails && !has_addresses) {
        item_string += "!";
      }
    }
    if (has_emails) {
      if (has_phones && has_addresses) {
        item_string += ", ";
      } else if (has_phones && !has_addresses) {
        item_string += " and ";
      }

      if (email_count === 1) {
        item_string += "1 email";
      } else {
        item_string += email_count + " emails";
      }

      if (!has_addresses) {
        if (email_count === 1) {
          item_string += " address!";
        } else {
          item_string += " addresses!";
        }
      }
    }

    if (has_addresses) {
      if (has_phones && has_emails) {
        item_string += ", ";
      } else if ((has_phones && !has_emails) || (!has_phones && has_emails)) {
        item_string += " and ";
      }

      if (address_count === 1) {
        item_string += "1 additional address";
      } else {
        item_string += address_count + " additional addresses";
      }

      item_string += "!";
    }

    if (has_emails || has_phones) {
      if (has_emails && has_phones) {
        contact_string =
          " You can now choose to contact the owner via email, phone or ";
      } else if (has_emails && !has_phones) {
        contact_string =
          " You can now choose to contact the owner via email or ";
      } else if (has_phones) {
        contact_string =
          " You can now choose to contact the owner via phone or ";
      }
    } else {
      contact_string = " You can now";
    }
    var bold_contract_string = "";
    if (has_addresses) {
      if (active_property.deal.skip_trace_mailing_addresses_count === 1) {
        bold_contract_string =
          " send mail to both associated owner addresses. ";
      } else {
        var all_address_count =
          active_property.deal.skip_trace_mailing_addresses_count + 1;
        bold_contract_string =
          " send mail to all " +
          all_address_count +
          " associated owner addresses. ";
      }
    } else {
      bold_contract_string = " send mail to the original owner address. ";
    }
    if (phone_count > 0 || address_count > 0 || email_count > 0) {
      return (
        <Copy>
          We added <Bold>{item_string}</Bold>
          {contact_string}
          <Bold>{bold_contract_string}</Bold>
        </Copy>
      );
    }
  }
  render() {
    const { active_property, colors, owner_info } = this.props;
    if (active_property.deal) {
      if (owner_info.owner_name && owner_info.owner_name !== "") {
        if (
          active_property &&
          active_property.deal &&
          active_property.deal.updating &&
          active_property.deal.updating.is_updating &&
          (active_property.deal.updating.updating_type ==
            "skip_trace_leads_v2" ||
            active_property.deal.updating.updating_type == "skip_trace_leads" ||
            active_property.deal.updating.updating_type == "skip_trace_lead" ||
            active_property.deal.updating.updating_type == "skip_trace")
        ) {
          return (
            <Card
              style={{
                marginBottom: 10
              }}
            >
              <CardBody style={{ padding: 15 }}>
                <Row>
                  <Wrapper style={{ marginRight: 10, flex: 1 }}>
                    <Title>Skip Tracing...</Title>
                    {!!this.props.active_property.deal.updating
                      .updating_text ? (
                      <Copy>
                        {this.props.active_property.deal.updating.updating_text}
                      </Copy>
                    ) : null}
                  </Wrapper>
                  <Spin size="small" />
                </Row>
              </CardBody>
            </Card>
          );
        } else if (
          active_property &&
          active_property.deal &&
          (!active_property.deal.updating ||
            !active_property.deal.updating.is_updating) &&
          active_property.deal.did_skip_trace != 1
        ) {
          return (
            <Card
              style={{
                marginBottom: 10
              }}
            >
              <CardBody style={{ padding: 15 }}>
                <Wrapper>
                  <Row>
                    <Wrapper style={{ flex: 1 }}>
                      <Copy>
                        <Bold>Skip Trace Owner</Bold>
                      </Copy>
                      <Copy>
                        Search phone numbers, email addresses and additional
                        mailing addresses.
                      </Copy>
                    </Wrapper>

                    <Row>
                      <PillButton
                        primary={true}
                        style={{ margin: 0 }}
                        onPress={() => {
                          skipTrace({
                            props: this.props,
                            properties: [active_property],
                            total_property_count: 1
                          });
                        }}
                      >
                        Skip Trace
                      </PillButton>
                    </Row>
                  </Row>
                </Wrapper>
              </CardBody>
            </Card>
          );
        } else {
          if (active_property.deal.skip_trace_successful == 1) {
            return (
              <Card
                style={{
                  backgroundColor: colors.success_color_muted,
                  marginBottom: 10
                }}
              >
                <Wrapper style={{ padding: 15 }}>
                  <Copy>
                    <Bold>Skip trace successful</Bold>
                  </Copy>
                  {this.renderSkipTraceText()}
                </Wrapper>
              </Card>
            );
          }
          return (
            <Card
              style={{
                backgroundColor: colors.error_color_muted,
                marginBottom: 10
              }}
            >
              <Wrapper style={{ padding: 15 }}>
                <Copy>
                  <Bold>Skip trace failed</Bold>
                </Copy>
                <Copy>
                  We couldn't find and additional information for this owner
                  from skip tracing. You will not be charged.
                </Copy>
              </Wrapper>
            </Card>
          );
        }
      }
    }

    return null;
  }
}

export default SkipTraceButton;
